import type { Project } from "@/data/projects";
import { useLocale } from "@/i18n/locale";
import { ui } from "@/i18n/ui";
import { TagList } from "./Tag";

export function ProjectCard({ project, index }: { project: Project; index: number }) {
  const { t } = useLocale();
  const number = String(index + 1).padStart(2, "0");
  const title = t(project.title);

  return (
    <article className="group grid gap-4 border-t border-border py-8 sm:grid-cols-[3rem_1fr] sm:gap-6">
      <div
        aria-hidden="true"
        className="font-mono text-sm text-faint transition-colors group-hover:text-accent"
      >
        {number}
      </div>

      <div className="space-y-3">
        <div className="space-y-1">
          <h3 className="text-lg font-medium tracking-tight text-balance">{title}</h3>
          <p className="label text-faint">
            {project.org}
            {project.role ? ` · ${t(project.role)}` : ""}
          </p>
        </div>

        <p className="max-w-2xl text-[15px] leading-relaxed text-muted text-pretty">
          <span className="text-text">{t(project.summary)}</span> {t(project.detail)}
        </p>

        <TagList items={project.tags} label={`${t(ui.technologiesUsedOn)} ${title}`} />
      </div>
    </article>
  );
}
